import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  title: {
    id: 'course-authoring.course-outline.empty-placeholder.title',
    defaultMessage: 'No course outline yet',
  },
  description: {
    id: 'course-authoring.course-outline.empty-placeholder.title',
    defaultMessage: 'Share updates, ask questions, or start a discussion.',
  },
  button: {
    id: 'course-authoring.course-outline.empty-placeholder.button.new-section',
    defaultMessage: 'New section',
  },
  tooltip: {
    id: 'course-authoring.course-outline.empty-placeholder.button.tooltip',
    defaultMessage: 'Click to add a new section',
  },
});

export default messages;
